import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { submit } from 'redux-form';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { getPacks } from '../../actions/packs';
import ModalDialog from '../../components/ModalDialog';
import { defaultPackOf } from '../../packNav';
import PackItemsList from './PackItemsList';

const PackItemsTab = ({ packId, kind }) => {
  const dispatch = useDispatch();
  const { items, itemsCount, selected } = useSelector(kind.select);
  const packs = useSelector((state) => state.packs.packs);
  const [adding, setAdding] = useState(false);

  const handleCreate = async (values) => {
    kind.validate(values);
    await dispatch(kind.create(values));
    setAdding(false);
    dispatch(getPacks()); // counts, and the list refetches
  };

  const { Form } = kind;
  return (
    <>
      <Button color="primary" startIcon={<AddIcon />} onClick={() => setAdding(true)} style={{ margin: '8px 0' }}>
        Ajouter
      </Button>
      <PackItemsList packId={packId} kind={kind} items={items} itemsCount={itemsCount} selected={selected} packs={packs} />
      <ModalDialog
        title={kind.addTitle}
        content={adding ? <Form onSubmit={handleCreate} initialValues={{ pack: defaultPackOf(packId) }} /> : null}
        isVisible={adding}
        onConfirm={() => dispatch(submit(kind.formName))}
        onClose={() => setAdding(false)}
      />
    </>
  );
};

PackItemsTab.propTypes = {
  packId: PropTypes.string.isRequired,
  kind: PropTypes.object.isRequired,
};

export default PackItemsTab;
